import React from 'react';
import styled from '@mui/material/styles/styled';
import { TableCell, Box } from '@mui/material';
import Typography from '../../Typography';
import { isEmpty } from '../../../utils';
import Actions from '../../Actions';
var TableCellRoot = styled(TableCell)({
    height: 54,
    padding: '0 16px',
    borderBottom: '1px solid #f4f4f4',
});
var ActionRoot = styled(Box)(function (_a) {
    var selected = _a.selected;
    var isSelected = selected && selected.length > 0;
    return {
        position: 'absolute',
        left: 60,
        top: 0,
        right: 0,
        display: isSelected ? 'flex' : 'none',
        zIndex: 1,
        height: 54,
        backgroundColor: '#fafafa',
        alignItems: 'center',
    };
});
var ActionText = styled(Typography)({
    color: '#4BB051',
    fontSize: '13px',
    fontWeight: 400,
    marginRight: 10,
    marginLeft: 5,
});
var TheadCell = function (_a) {
    var label = _a.label, type = _a.type, data = _a.data, selected = _a.selected, nameText = _a.nameText, batchActions = _a.batchActions, thReader = _a.thReader;
    if (thReader === null)
        return null;
    var Cell = function () {
        //处理自定义render返回
        if (thReader) {
            return React.createElement(React.Fragment, null, thReader({ data: data }));
        }
        return (React.createElement(Typography, { color: 'secondary', weight: "medium", variant: 'body2' }, label));
    };
    var CheckActions = function () {
        if (type !== 'checkbox')
            return null;
        if (isEmpty(batchActions))
            return null;
        var len = selected.length;
        var text = function () {
            var defaultText = "\u5DF2\u9009\u62E9" + len + "\u4E2A";
            if (nameText) {
                if (typeof nameText === 'string')
                    return "" + defaultText + nameText;
                if (typeof nameText === 'function')
                    return nameText('checkbox');
            }
            return defaultText;
        };
        return (React.createElement(ActionRoot, { selected: selected },
            React.createElement(ActionText, null, text()),
            React.createElement(Actions, { actions: batchActions, data: selected })));
    };
    return (React.createElement(TableCellRoot, null,
        React.createElement(Cell, null),
        React.createElement(CheckActions, null)));
};
export default TheadCell;
